<template>
  <section class="highlightBlock -archive" v-if="archives.length">
    <div class="u-containar">
      <h2 class="highlightBlock_heading">イベント・セミナー アーカイブ</h2>
      <div class="cards">
        <EventCardArchive
          v-for="e in archives"
          :key="e.id"
          :event="e"
          rectangle
        />
      </div>
      <Button
        label="イベント・セミナー アーカイブ一覧"
        primary
        href="/events/archives/list"
        :handleClick="
          () => {
            $router.push('/events/archives/list')
          }
        "
      />
    </div>
  </section>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import EventCardArchive from '@/components/block/EventCardArchive.vue'
import Button from '@/components/elements/Button.vue'
import { useEvent } from '@/provider/event'

export default defineComponent({
  name: 'MagazineEventArchive',
  components: {
    EventCardArchive,
    Button
  },

  setup() {
    const { loadArchives, archives: archivesBase } = useEvent()
    loadArchives({
      per_page: 4,
      page: undefined,
      category: undefined,
      tag: undefined,
      type: undefined
    })
    const archives = computed(() => archivesBase.value.slice(0, 4))

    return {
      archives
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables'as var;
.highlightBlock {
  padding: 30px 0 39px;
  background-color: #eee;
  &.-archive {
    margin-top: 56px;
    background: #ffe869;
    background: -moz-linear-gradient(left, #ffe869 0%, #caf58f 100%);
    background: -webkit-linear-gradient(left, #ffe869 0%, #caf58f 100%);
    background: linear-gradient(to right, #ffe869 0%, #caf58f 100%);
  }
}

.highlightBlock_heading {
  font-weight: 500;
  font-size: 2rem;
  letter-spacing: 0.03em;
  line-height: 1.6;

  > span {
    color: var.$color-main-text;
  }

  & + * {
    margin-top: 20px;
  }
}
.u-containar {
  margin-top: 15px;

  > p:first-child {
    margin-top: 29px;
    margin-bottom: 40px;
    font-size: 1.6rem;
    line-height: 1.875;
  }
}
::v-deep(.recommend_list .magazineCard_heading) {
  font-size: 1.4rem;
  line-height: 1.5;
}

.cards {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  margin-bottom: 30px;
  @include mixins.media() {
    grid-template-columns: repeat(3, 1fr);
  }
}
.-archive {
  .button {
    max-width: 320px;
  }
  .cards {
    @include mixins.media() {
      grid-template-columns: repeat(4, 1fr);
    }
  }
}
</style>
